import { gsap } from 'gsap'

export default class BusinessStackCards {
  constructor(container) {
    this.container = container
    this.units = [...container.querySelectorAll('.top-business-unit')]
    if (this.units.length < 2) return

    this.remMultiplier = 3 // 3rem
    this.baseOffset = 0
    this.stickPoints = []
    this.cardHeights = []
    this.exitDistances = []
    this.lastScrollY = null
    this.lastViewportHeight = null
    this.lastTranslations = []

    this.measure()

    // GSAP tickerでLenis/ScrollTriggerと同期して毎フレーム更新
    gsap.ticker.add(() => this.update())

    let resizeRaf
    window.addEventListener('resize', () => {
      cancelAnimationFrame(resizeRaf)
      resizeRaf = requestAnimationFrame(() => this.measure())
    })
  }

  measure() {
    // transformリセット + stickyを一時解除して自然なフロー位置を計測
    this.units.forEach(unit => {
      unit.style.setProperty('--_translate-y', '0px')
      unit.style.setProperty('--_inset-block-start', '0px')
      unit.style.position = 'relative'
    })

    // リフロー強制（sticky解除後の正確なレイアウトを反映）
    this.container.offsetHeight

    // htmlのcomputed font-sizeから3rem相当のpx値を算出
    const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize)
    this.baseOffset = rootFontSize * this.remMultiplier

    // 各ユニットの自然なドキュメント位置と高さを算出
    const scrollY = window.scrollY
    this.stickPoints = this.units.map(unit => {
      const absTop = unit.getBoundingClientRect().top + scrollY
      return absTop - this.baseOffset
    })
    this.cardHeights = this.units.map(unit => unit.offsetHeight)

    // 退出移動量 = sticky位置(baseOffset) + __headerの高さ - 下padding
    // → __headerの下padding位置でちょうどビューポート上端に消える
    this.exitDistances = this.units.map(unit => {
      const header = unit.querySelector('.top-business-unit__header')
      if (!header) return 0
      const headerHeight = header.offsetHeight
      const headerPaddingBottom = parseFloat(getComputedStyle(header).paddingBlockEnd)
      return this.baseOffset + headerHeight - headerPaddingBottom
    })

    // stickyを復元し、inset-block-startを設定
    this.units.forEach(unit => {
      unit.style.position = ''
      unit.style.setProperty('--_inset-block-start', `${this.baseOffset}px`)
    })

    // 再計測直後に正しいtranslate値を即反映
    this.lastScrollY = null
    this.lastTranslations = []
    this.update()
  }

  update() {
    if (this.units.length < 2) return

    const scrollY = window.scrollY
    const n = this.units.length
    const vh = window.innerHeight
    if (scrollY === this.lastScrollY && vh === this.lastViewportHeight) return
    this.lastScrollY = scrollY
    this.lastViewportHeight = vh

    this.units.forEach((unit, i) => {
      let ty = 0

      if (i + 1 < n) {
        // 次カードのドキュメント上の絶対位置
        const absTopNext = this.stickPoints[i + 1] + this.baseOffset
        // 退出開始: 次カードがビューポート中央に来たとき
        const transitionStart = absTopNext - vh / 2
        // 退出完了: 次カードが固定位置(48px)に到達
        const transitionEnd = this.stickPoints[i + 1]
        const range = transitionEnd - transitionStart

        if (range > 0 && scrollY >= transitionStart) {
          const progress = Math.min(1, (scrollY - transitionStart) / range)
          // 退出量 = このカードの__headerの高さ - 下padding
          ty = -this.exitDistances[i] * progress
        }
      }

      if (ty !== this.lastTranslations[i]) {
        unit.style.setProperty('--_translate-y', `${ty}px`)
        this.lastTranslations[i] = ty
      }
    })
  }
}
